import React from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';

import FormModal from '../../Modals/FormModal';
import InputField from '../../Forms/Input/InputField';

interface EditProductSubCategoryPopupProps {
  popupOpen: boolean;
  setPopupOpen: (open: boolean) => void;

  onUpdate: (data: {
    id: number;
    name: string;
    categoryId: number;
  }) => void;

  selectedSubCategory: {
    id: number;
    name: string;
    categoryId: number;
    categoryName: string;
  } | null;
}

const EditProductSubCategoryPopup: React.FC<
  EditProductSubCategoryPopupProps
> = ({
  popupOpen,
  setPopupOpen,
  onUpdate,
  selectedSubCategory,
}) => {

  const validationSchema = Yup.object({
    name: Yup.string()
      .min(
        2,
        'El nombre debe tener al menos 2 caracteres'
      )
      .required(
        'El nombre de la subcategoría es obligatorio'
      ),
  });

  const formik = useFormik({

    initialValues: {
      id: selectedSubCategory?.id || 0,
      categoryId:
        selectedSubCategory?.categoryId || 0,
      name:
        selectedSubCategory?.name || '',
    },

    validationSchema,

    onSubmit: (values) => {

      onUpdate(values);

      setPopupOpen(false);
    },

    enableReinitialize: true,
  });

  return (
    <FormModal
      isOpen={popupOpen}
      onClose={() => setPopupOpen(false)}
      title="Editar Subcategoría"
      maxWidth="max-w-md"
    >
      <form
        onSubmit={formik.handleSubmit}
        className="mt-4"
      >

        <div className="mb-5">

          <label className="mb-2 block text-sm font-medium text-black dark:text-white">
            Categoría
          </label>

          <div className="rounded border border-stroke bg-gray-2 px-4 py-3 dark:border-strokedark dark:bg-meta-4">
            <span className="text-black dark:text-white">
              {selectedSubCategory?.categoryName}
            </span>
          </div>

        </div>

        <InputField
          label="Nombre"
          name="name"
          type="text"
          value={formik.values.name}
          onChange={formik.handleChange}
          error={
            formik.touched.name &&
            formik.errors.name
              ? formik.errors.name
              : undefined
          }
          iconKey="edit"
        />

        <button
          type="submit"
          className="w-full rounded bg-primary px-4 py-2 font-medium text-white hover:bg-opacity-90"
        >
          Guardar Cambios
        </button>

      </form>
    </FormModal>
  );
};

export default EditProductSubCategoryPopup;